const PASSWORD_CREATED = 'Password created successfully!'
const CONFIRMATION_MAIL = 'Confirmation mail sent successfully'
const SUCCESSFUL_LOGIN = 'You have successfully logged in.'
const PASSWORD_RESET = 'Your new password is successfully created. Please log in to access the portal!'


export {PASSWORD_CREATED, CONFIRMATION_MAIL,SUCCESSFUL_LOGIN , PASSWORD_RESET};


